enum SessionStorage {
  SENDING = "sending",
  LISTENING = "listening",
  INTERVIEW_STATE = "interview_state",
  SCORE_REPORT = "score_report",
  OVERALL_REPORT = "overall_report",
}
export { SessionStorage };
